export const REDUCER_NAME="vendorProductsSlice";
export interface iVendorProductDTO {
    product: {
      currency: string;
    priceIncreasePercent: any;
      measurement: string;
      discount: number;
      taxRate: number;
    
      id?: string;
      vendor_id: string;
      title: string;
      sku: string;
      product_type: string;
      category_id: string;
      subCategory:string
      description: string;
      product_image: string | null;
      images:string[];
      videos:string[];
      price: string;
      cost_price: string;
      packagingCharges?:number;
      isPackagingCharges?:boolean;
      taxesAndCharges: string;
      sale_price: string;
      retail_price: string;
      rating?: number;
      isFeaturedProduct?:boolean;
      inventory_status: string;
      availability: string;
      global_trade_item_number: string;
      manufacturer_part_number: string;
      brand_name: string;
      product_upc_ean: string;
      is_shipping_free: number;
      page_title: string;
      meta_keywords: string;
      meta_description: string;
      product_url: string;
      delivery_event_name: string;
      delivery_from_date: string | null;
      delivery_to_date: string | null;
      created_at: string;
      updated_at: string;
      currentStock: string|number;
      lowStock: string|number;
      customFields?:Array<{label:string,value:string}>;
            shippingPrice?: number;
      internationalshippingPrice:number;
            tags?: Array<string>;
      sizes?: string[];
      color_images?: string[];
      about: string;
      unit: string;
      taxOptions: string;
      brand: string;
      imported_product_reference?:string|null;
      vendorstatus?:string;
    };
    reviews?:any[]

  }

  export interface iVendorProductsState {
  vendorProductsList: iVendorProductDTO[] | null;
  isLoading: boolean;
  errorMessage: string | null;
}
